import { FC, useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { BLUE_DARK_COLORS_VARIANTS, LIGHT_COLORS_VARIANTS_OPACITY } from '@/utils/constants/colors'
import { FilterStatusElement, StatusFilterProps } from './FilterStatusElement'

export interface StatusFilterModuleProps {
  elements: Omit<StatusFilterProps, 'onClick' | 'activeId'>[]
  onFilterChange?: (id: number) => void
  initialActiveId?: number | null
}

export const FilteringByStatus: FC<StatusFilterModuleProps> = ({
  elements,
  onFilterChange,
  initialActiveId,
}) => {
  const [activeStatusId, setActiveStatusId] = useState<number | null>(initialActiveId ?? null)

  useEffect(() => {
    setActiveStatusId(initialActiveId ?? null)
  }, [initialActiveId])

  const handleElementClick = (statusId: number) => {
    setActiveStatusId(statusId)
    onFilterChange?.(statusId)
  }

  return (
    <Box
      display="flex"
      width="fit-content"
      gap={1}
      justifyContent="center"
      alignItems="center"
      borderRadius="2rem"
      border={`1px solid ${LIGHT_COLORS_VARIANTS_OPACITY[50]}`}
      p="0.25rem"
      sx={{
        backdropFilter: 'blur(4px)',
        backgroundColor: LIGHT_COLORS_VARIANTS_OPACITY[1050],
        boxShadow: `0 4px 24px ${BLUE_DARK_COLORS_VARIANTS[300]}`,
      }}
    >
      <Box
        display="flex"
        width="100%"
        gap={2}
        justifyContent="center"
        alignItems="center"
        flexShrink={0}
        sx={{
          overflowX: 'auto',
        }}
      >
        {elements.map((element) => (
          <FilterStatusElement
            key={element.statusId}
            {...element}
            onClick={handleElementClick}
            activeId={activeStatusId}
          />
        ))}
      </Box>
    </Box>
  )
}
